/**
 * initial setup for highcharts
 */
define('atn/highchartsConfig',[],
    function() {
        'use strict';
        var chartConfig = {
            legend: {
                    itemStyle: {
                    fontFamily: 'Arial',
                    fontWeight: 'bold'
                }
            }
        };

        return {
            chartConfig:chartConfig
        };

    });
